import React from 'react';

const StepComplete = ({ nextStep }) => (
  <div className="onboarding-content center">
    <div>
      <div className="onboarding-icon">
        <i className="fa fa-check"></i>
      </div>
      <h2 className="onboarding-heading large">You’re All Set!</h2>
      <p className="mt2 mb3">
        Check your inbox from The Information and enjoy reading the best in tech news.
      </p>
      <button onClick={nextStep} className="button button-red button-stretch button-small">
        Close
      </button>
    </div>
  </div>
);

export default StepComplete;
